import { Container } from 'pixi.js';
import { DioramaComingSoonLayout } from '../../../../layouts/dioramas/DioramaComingSoonLayout';

export class DioramaComingSoonView extends Container {
  private readonly layout = new DioramaComingSoonLayout();

  constructor() {
    super();

    this.layout.root.props({
      parent: this,
      y: -250,
    });

    this.startAnimationLoop();
  }

  public destroy(): void {
    super.destroy({ children: true });
  }

  private startAnimationLoop(): void {
    const { dioramaLock, dioramaText } = this.layout;

    dioramaLock.tweenTo({ pivotY: 5 }, 2000, 'sinInOut', true, 0, -1, true);

    const shakeAngle = 0.03;
    dioramaText
      .tweenTo({ rotation: [0, shakeAngle, -shakeAngle, shakeAngle, -shakeAngle, 0] }, 1200, 'sinInOut', false, 0, -1)
      .repeatDelay(4000)
      .start();
  }
}
